import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { RiparianRequestsComponent } from './components/riparian-requests/riparian-requests.component';
import { HomeParkingRequestsComponent } from './components/home-parking-requests/home-parking-requests.component';
import { ParkingRequestDetailsComponent } from './components/parking-request-details/parking-request-details.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { PopUpDeniedRequestComponent } from './components/pop-up-denied-request/pop-up-denied-request.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PopUpMessageComponent } from './components/pop-up-message/pop-up-message.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DataTablesModule } from 'angular-datatables';
import { MatSidenavModule } from '@angular/material/sidenav';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
import {
  provideAnalytics,
  getAnalytics,
  ScreenTrackingService,
  UserTrackingService,
} from '@angular/fire/analytics';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { providePerformance, getPerformance } from '@angular/fire/performance';
import {
  provideRemoteConfig,
  getRemoteConfig,
} from '@angular/fire/remote-config';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HotToastModule } from '@ngneat/hot-toast';
import { MatDividerModule } from '@angular/material/divider';
import { UsersComponent } from './components/users/users.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { ParkingAgentsComponent } from './components/parking-agents/parking-agents.component';
import { CreateUserComponent } from './components/create-user/create-user.component';
import { TicketsComponent } from './components/tickets/tickets.component';
import { SubscriptionsComponent } from './components/subscriptions/subscriptions.component';
import { DatePipe } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { AlertModule } from '@full-fledged/alerts';
import { PopUpNotificationComponent } from './components/pop-up-notification/pop-up-notification.component';
import { errorInterceptorProviders } from './interceptors/error.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    SidebarComponent,
    RiparianRequestsComponent,
    HomeParkingRequestsComponent,
    ParkingRequestDetailsComponent,
    PopUpDeniedRequestComponent,
    PopUpMessageComponent,
    UsersComponent,
    UserDetailsComponent,
    ParkingAgentsComponent,
    CreateUserComponent,
    TicketsComponent,
    SubscriptionsComponent,
    ConfirmationDialogComponent,
    PopUpNotificationComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatCardModule,
    MatToolbarModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatCheckboxModule,
    DataTablesModule,
    MatSidenavModule,
    HttpClientModule,
    HotToastModule,
    MatDividerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AlertModule.forRoot({
      maxMessages: 5,
      timeout: 5000,
      positionX: 'right',
      positionY: 'top',
    }),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    provideAuth(() => getAuth()),
    provideDatabase(() => getDatabase()),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions()),
    provideMessaging(() => getMessaging()),
    providePerformance(() => getPerformance()),
    provideRemoteConfig(() => getRemoteConfig()),
    provideStorage(() => getStorage()),
  ],
  providers: [
    errorInterceptorProviders,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    ScreenTrackingService,
    UserTrackingService,
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
